/**
 * Table Columns Configuration
 * Defines column configurations for all tables
 */

// Orders Table Columns
export const ORDERS_COLUMNS = [
  { id: 'sn', label: 'SN', minWidth: 50, align: 'center' },
  { id: 'clientName', label: 'Client Name', minWidth: 150 },
  { id: 'location', label: 'Location', minWidth: 120 },
  { id: 'orderDate', label: 'Order Date', minWidth: 120 },
  { id: 'orderStatus', label: 'Order Status', minWidth: 150 },
  { id: 'orderValue', label: 'Order Value', minWidth: 120, align: 'right', format: (value) => `₹${value.toLocaleString()}` },
  { id: 'quotationNumber', label: 'Quotation Number', minWidth: 150 },
  { id: 'action', label: 'Action', minWidth: 100, align: 'center' }
];

// Quotations Table Columns
export const QUOTATIONS_COLUMNS = [
  { id: 'sn', label: 'SN', minWidth: 50, align: 'center' },
  { id: 'quotationNumber', label: 'Quotation Number', minWidth: 150 },
  { id: 'status', label: 'Status', minWidth: 150 },
  { id: 'lastUpdatedOn', label: 'Last Updated On', minWidth: 120 },
  { id: 'clientName', label: 'Client Name', minWidth: 150 },
  { id: 'location', label: 'Location', minWidth: 120 },
  { id: 'initialQuotationDate', label: 'Initial Quotation Date', minWidth: 150 },
  { id: 'revisedQuotationDate', label: 'Revised Quotation Date', minWidth: 150 },
  { id: 'quotationValue', label: 'Quotation Value', minWidth: 120, align: 'right', format: (value) => `₹${value.toLocaleString()}` },
  { id: 'revisions', label: 'Revisions', minWidth: 80, align: 'center' },
  { id: 'revise', label: 'Revise', minWidth: 80, align: 'center' },
  { id: 'action', label: 'Action', minWidth: 100, align: 'center' },
  { id: 'delete', label: 'Delete', minWidth: 80, align: 'center' }
];

// Enquiries Table Columns
export const ENQUIRIES_COLUMNS = [
  { id: 'sn', label: 'SN', minWidth: 50, align: 'center' },
  { id: 'enquiryNumber', label: 'Enquiry Number', minWidth: 150 },
  { id: 'status', label: 'Status', minWidth: 150 },
  { id: 'clientName', label: 'Client Name', minWidth: 150 },
  { id: 'locationDisplay', label: 'Location', minWidth: 120 },
  { id: 'nextFollowUpOn', label: 'Next Follow Up', minWidth: 120 },
  { id: 'initialEnquiryDate', label: 'Initial Enquiry Date', minWidth: 150 },
  { id: 'mainProductType', label: 'Requirements', minWidth: 200 },
  { id: 'action', label: 'Action', minWidth: 100, align: 'center' },
  { id: 'delete', label: 'Delete', minWidth: 80, align: 'center' }
];

